import React from "react";
import style from "./WeatherWeekly.module.scss";
import { map } from "lodash";
export function WeatherWeekly(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: style.container
  }, /*#__PURE__*/React.createElement("div", {
    className: style.topContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: style.upperLayer
  }, /*#__PURE__*/React.createElement("img", {
    src: props.current_weather.weather_icon,
    alt: "Weather Image",
    className: style.weatherImage
  }), /*#__PURE__*/React.createElement("div", {
    className: style.weatherInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: style.temperature
  }, props.current_weather.current_temperature), /*#__PURE__*/React.createElement("div", {
    className: style.description
  }, props.current_weather.weather_condition))), /*#__PURE__*/React.createElement("div", {
    className: style.middleLayer
  }, map(props.weekly_weather, function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: style.weatherItem,
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: style.name
    }, item.day), /*#__PURE__*/React.createElement("img", {
      src: item.daily_weather_icon,
      alt: "UV",
      className: style.icon
    }), /*#__PURE__*/React.createElement("div", {
      className: style.value
    }, item.daily_temperature));
  }))), /*#__PURE__*/React.createElement("div", {
    className: style.lowerLayer
  }, /*#__PURE__*/React.createElement("img", {
    src: props.weekly_weather[0].health_tip.tip_icon,
    alt: "UV",
    className: style.lowerLayerIcon
  }), props.weekly_weather[0].health_tip.tip_text));
}